<app-card [className]="'card--summary'">
  <div class="card--summary__inner about">
    <div class="card--summary__head">
      <div>
        <h2>{{ 'project.home.about.title' | translate }}</h2>
      </div>
    </div>
    <div class="card__content">
      <div
        class="card--summary__description"
        [appTranslateText]="customer.description | truncate : 300"
        [html]="customer.description | truncate : 300"
        [language]="language"
      ></div>
    </div>
    <a class="card--summary__link" tabindex="0" (click)="goToTab('about-us')">
      {{
        'project.home.about.showall' | translate : { project: customer.name }
      }}
    </a>
  </div>
</app-card>

<app-card [className]="'card--summary'" *ngIf="latestUpdate">
  <div class="card--summary__inner update">
    <div class="card--summary__head">
      <div>
        <h2>{{ 'project.home.update.title' | translate }}</h2>
      </div>
    </div>
    <div class="card__content">
      <div
        class="card--summary__description"
        [appTranslateText]="latestUpdate.content | truncate : 300"
        [language]="latestUpdate.project?.language ?? en"
        [html]="latestUpdate.content | truncate : 300"
      ></div>
    </div>
    <a class="card--summary__link" tabindex="0" (click)="goToTab('updates')">
      {{
        'project.home.update.showall' | translate : { project: customer.name }
      }}
    </a>
  </div>
</app-card>
